import type { PercentileCurvePoint } from './types'

// Source: WHO Child Growth Standards (2006)
// https://www.who.int/tools/child-growth-standards/standards/

export const bmiForAgeBoys: PercentileCurvePoint[] = [
  { month: 0, p3: 11.3, p15: 12.2, p50: 13.4, p85: 14.8, p97: 16.1 },
  { month: 1, p3: 12.6, p15: 13.6, p50: 14.9, p85: 16.4, p97: 17.6 },
  { month: 2, p3: 13.8, p15: 14.9, p50: 16.3, p85: 17.8, p97: 19.2 },
  { month: 3, p3: 14.4, p15: 15.5, p50: 16.9, p85: 18.5, p97: 19.8 },
  { month: 4, p3: 14.7, p15: 15.7, p50: 17.2, p85: 18.7, p97: 20.1 },
  { month: 5, p3: 14.8, p15: 15.9, p50: 17.3, p85: 18.9, p97: 20.2 },
  { month: 6, p3: 14.9, p15: 15.9, p50: 17.3, p85: 18.9, p97: 20.3 },
  { month: 7, p3: 14.9, p15: 15.9, p50: 17.3, p85: 18.9, p97: 20.3 },
  { month: 8, p3: 14.9, p15: 15.9, p50: 17.3, p85: 18.8, p97: 20.2 },
  { month: 9, p3: 14.8, p15: 15.8, p50: 17.2, p85: 18.7, p97: 20.1 },
  { month: 10, p3: 14.7, p15: 15.7, p50: 17, p85: 18.6, p97: 19.9 },
  { month: 11, p3: 14.6, p15: 15.6, p50: 16.9, p85: 18.4, p97: 19.8 },
  { month: 12, p3: 14.5, p15: 15.5, p50: 16.8, p85: 18.3, p97: 19.6 },
  { month: 13, p3: 14.4, p15: 15.4, p50: 16.7, p85: 18.1, p97: 19.5 },
  { month: 14, p3: 14.3, p15: 15.3, p50: 16.6, p85: 18, p97: 19.3 },
  { month: 15, p3: 14.2, p15: 15.2, p50: 16.4, p85: 17.9, p97: 19.2 },
  { month: 16, p3: 14.2, p15: 15.1, p50: 16.3, p85: 17.8, p97: 19.1 },
  { month: 17, p3: 14.1, p15: 15, p50: 16.2, p85: 17.6, p97: 18.9 },
  { month: 18, p3: 14, p15: 14.9, p50: 16.1, p85: 17.5, p97: 18.8 },
  { month: 19, p3: 13.9, p15: 14.8, p50: 16.1, p85: 17.4, p97: 18.7 },
  { month: 20, p3: 13.9, p15: 14.8, p50: 16, p85: 17.4, p97: 18.6 },
  { month: 21, p3: 13.8, p15: 14.7, p50: 15.9, p85: 17.3, p97: 18.6 },
  { month: 22, p3: 13.8, p15: 14.6, p50: 15.8, p85: 17.2, p97: 18.5 },
  { month: 23, p3: 13.7, p15: 14.6, p50: 15.8, p85: 17.1, p97: 18.4 },
  { month: 24, p3: 13.9, p15: 14.8, p50: 16, p85: 17.4, p97: 18.7 },
  { month: 25, p3: 13.9, p15: 14.8, p50: 16, p85: 17.4, p97: 18.6 },
  { month: 26, p3: 13.8, p15: 14.7, p50: 15.9, p85: 17.3, p97: 18.6 },
  { month: 27, p3: 13.8, p15: 14.7, p50: 15.9, p85: 17.3, p97: 18.5 },
  { month: 28, p3: 13.8, p15: 14.7, p50: 15.9, p85: 17.2, p97: 18.5 },
  { month: 29, p3: 13.7, p15: 14.6, p50: 15.8, p85: 17.2, p97: 18.4 },
  { month: 30, p3: 13.7, p15: 14.6, p50: 15.8, p85: 17.2, p97: 18.4 },
  { month: 31, p3: 13.7, p15: 14.5, p50: 15.8, p85: 17.1, p97: 18.4 },
  { month: 32, p3: 13.6, p15: 14.5, p50: 15.7, p85: 17.1, p97: 18.3 },
  { month: 33, p3: 13.6, p15: 14.5, p50: 15.7, p85: 17, p97: 18.3 },
  { month: 34, p3: 13.5, p15: 14.4, p50: 15.7, p85: 17, p97: 18.2 },
  { month: 35, p3: 13.5, p15: 14.4, p50: 15.6, p85: 17, p97: 18.2 },
  { month: 36, p3: 13.5, p15: 14.4, p50: 15.6, p85: 17, p97: 18.2 },
  { month: 37, p3: 13.5, p15: 14.4, p50: 15.6, p85: 16.9, p97: 18.1 },
  { month: 38, p3: 13.4, p15: 14.3, p50: 15.5, p85: 16.9, p97: 18.1 },
  { month: 39, p3: 13.4, p15: 14.3, p50: 15.5, p85: 16.9, p97: 18.1 },
  { month: 40, p3: 13.4, p15: 14.3, p50: 15.5, p85: 16.8, p97: 18.1 },
  { month: 41, p3: 13.3, p15: 14.2, p50: 15.5, p85: 16.8, p97: 18 },
  { month: 42, p3: 13.3, p15: 14.2, p50: 15.4, p85: 16.8, p97: 18 },
  { month: 43, p3: 13.3, p15: 14.2, p50: 15.4, p85: 16.8, p97: 18 },
  { month: 44, p3: 13.3, p15: 14.2, p50: 15.4, p85: 16.8, p97: 18 },
  { month: 45, p3: 13.2, p15: 14.2, p50: 15.4, p85: 16.8, p97: 18 },
  { month: 46, p3: 13.2, p15: 14.1, p50: 15.4, p85: 16.7, p97: 18 },
  { month: 47, p3: 13.2, p15: 14.1, p50: 15.3, p85: 16.7, p97: 18 },
  { month: 48, p3: 13.2, p15: 14.1, p50: 15.3, p85: 16.7, p97: 18 },
  { month: 49, p3: 13.2, p15: 14.1, p50: 15.3, p85: 16.7, p97: 18 },
  { month: 50, p3: 13.2, p15: 14.1, p50: 15.3, p85: 16.7, p97: 18 },
  { month: 51, p3: 13.1, p15: 14, p50: 15.3, p85: 16.7, p97: 18 },
  { month: 52, p3: 13.1, p15: 14, p50: 15.3, p85: 16.7, p97: 18 },
  { month: 53, p3: 13.1, p15: 14, p50: 15.3, p85: 16.7, p97: 18 },
  { month: 54, p3: 13.1, p15: 14, p50: 15.3, p85: 16.7, p97: 18 },
  { month: 55, p3: 13.1, p15: 14, p50: 15.2, p85: 16.7, p97: 18 },
  { month: 56, p3: 13.1, p15: 14, p50: 15.2, p85: 16.7, p97: 18 },
  { month: 57, p3: 13, p15: 14, p50: 15.2, p85: 16.7, p97: 18 },
  { month: 58, p3: 13, p15: 13.9, p50: 15.2, p85: 16.7, p97: 18 },
  { month: 59, p3: 13, p15: 13.9, p50: 15.2, p85: 16.7, p97: 18.1 },
  { month: 60, p3: 13, p15: 13.9, p50: 15.2, p85: 16.7, p97: 18.1 }
]

export const bmiForAgeGirls: PercentileCurvePoint[] = [
  { month: 0, p3: 11.2, p15: 12.1, p50: 13.3, p85: 14.7, p97: 15.9 },
  { month: 1, p3: 12.1, p15: 13.2, p50: 14.6, p85: 16.1, p97: 17.3 },
  { month: 2, p3: 13.2, p15: 14.3, p50: 15.8, p85: 17.4, p97: 18.8 },
  { month: 3, p3: 13.7, p15: 14.9, p50: 16.4, p85: 18, p97: 19.4 },
  { month: 4, p3: 14, p15: 15.2, p50: 16.7, p85: 18.3, p97: 19.8 },
  { month: 5, p3: 14.2, p15: 15.3, p50: 16.8, p85: 18.5, p97: 20 },
  { month: 6, p3: 14.3, p15: 15.4, p50: 16.9, p85: 18.6, p97: 20.1 },
  { month: 7, p3: 14.3, p15: 15.4, p50: 16.9, p85: 18.6, p97: 20.1 },
  { month: 8, p3: 14.3, p15: 15.4, p50: 16.8, p85: 18.5, p97: 20 },
  { month: 9, p3: 14.2, p15: 15.3, p50: 16.7, p85: 18.4, p97: 19.9 },
  { month: 10, p3: 14.1, p15: 15.2, p50: 16.6, p85: 18.2, p97: 19.7 },
  { month: 11, p3: 14, p15: 15.1, p50: 16.5, p85: 18.1, p97: 19.6 },
  { month: 12, p3: 13.9, p15: 15, p50: 16.4, p85: 17.9, p97: 19.4 },
  { month: 13, p3: 13.8, p15: 14.8, p50: 16.2, p85: 17.8, p97: 19.2 },
  { month: 14, p3: 13.7, p15: 14.7, p50: 16.1, p85: 17.7, p97: 19.1 },
  { month: 15, p3: 13.7, p15: 14.6, p50: 16, p85: 17.5, p97: 19 },
  { month: 16, p3: 13.6, p15: 14.6, p50: 15.9, p85: 17.4, p97: 18.8 },
  { month: 17, p3: 13.5, p15: 14.5, p50: 15.8, p85: 17.3, p97: 18.7 },
  { month: 18, p3: 13.4, p15: 14.4, p50: 15.7, p85: 17.2, p97: 18.6 },
  { month: 19, p3: 13.4, p15: 14.3, p50: 15.7, p85: 17.2, p97: 18.5 },
  { month: 20, p3: 13.3, p15: 14.3, p50: 15.6, p85: 17.1, p97: 18.5 },
  { month: 21, p3: 13.3, p15: 14.2, p50: 15.5, p85: 17, p97: 18.4 },
  { month: 22, p3: 13.3, p15: 14.2, p50: 15.5, p85: 17, p97: 18.3 },
  { month: 23, p3: 13.2, p15: 14.2, p50: 15.4, p85: 16.9, p97: 18.3 },
  { month: 24, p3: 13.5, p15: 14.4, p50: 15.7, p85: 17.2, p97: 18.5 },
  { month: 25, p3: 13.4, p15: 14.4, p50: 15.7, p85: 17.1, p97: 18.5 },
  { month: 26, p3: 13.4, p15: 14.4, p50: 15.6, p85: 17.1, p97: 18.5 },
  { month: 27, p3: 13.4, p15: 14.3, p50: 15.6, p85: 17.1, p97: 18.4 },
  { month: 28, p3: 13.4, p15: 14.3, p50: 15.6, p85: 17, p97: 18.4 },
  { month: 29, p3: 13.4, p15: 14.3, p50: 15.6, p85: 17, p97: 18.4 },
  { month: 30, p3: 13.3, p15: 14.3, p50: 15.5, p85: 17, p97: 18.3 },
  { month: 31, p3: 13.3, p15: 14.2, p50: 15.5, p85: 17, p97: 18.3 },
  { month: 32, p3: 13.3, p15: 14.2, p50: 15.5, p85: 16.9, p97: 18.3 },
  { month: 33, p3: 13.3, p15: 14.2, p50: 15.5, p85: 16.9, p97: 18.3 },
  { month: 34, p3: 13.2, p15: 14.2, p50: 15.4, p85: 16.9, p97: 18.2 },
  { month: 35, p3: 13.2, p15: 14.1, p50: 15.4, p85: 16.9, p97: 18.2 },
  { month: 36, p3: 13.2, p15: 14.1, p50: 15.4, p85: 16.9, p97: 18.2 },
  { month: 37, p3: 13.2, p15: 14.1, p50: 15.4, p85: 16.8, p97: 18.2 },
  { month: 38, p3: 13.2, p15: 14.1, p50: 15.4, p85: 16.8, p97: 18.2 },
  { month: 39, p3: 13.1, p15: 14.1, p50: 15.3, p85: 16.8, p97: 18.2 },
  { month: 40, p3: 13.1, p15: 14, p50: 15.3, p85: 16.8, p97: 18.2 },
  { month: 41, p3: 13.1, p15: 14, p50: 15.3, p85: 16.8, p97: 18.2 },
  { month: 42, p3: 13.1, p15: 14, p50: 15.3, p85: 16.8, p97: 18.2 },
  { month: 43, p3: 13, p15: 14, p50: 15.3, p85: 16.8, p97: 18.2 },
  { month: 44, p3: 13, p15: 14, p50: 15.3, p85: 16.8, p97: 18.2 },
  { month: 45, p3: 13, p15: 14, p50: 15.3, p85: 16.8, p97: 18.3 },
  { month: 46, p3: 13, p15: 13.9, p50: 15.3, p85: 16.8, p97: 18.3 },
  { month: 47, p3: 13, p15: 13.9, p50: 15.3, p85: 16.8, p97: 18.3 },
  { month: 48, p3: 12.9, p15: 13.9, p50: 15.3, p85: 16.8, p97: 18.3 },
  { month: 49, p3: 12.9, p15: 13.9, p50: 15.3, p85: 16.8, p97: 18.3 },
  { month: 50, p3: 12.9, p15: 13.9, p50: 15.3, p85: 16.8, p97: 18.3 },
  { month: 51, p3: 12.9, p15: 13.9, p50: 15.3, p85: 16.8, p97: 18.4 },
  { month: 52, p3: 12.9, p15: 13.9, p50: 15.2, p85: 16.9, p97: 18.4 },
  { month: 53, p3: 12.9, p15: 13.9, p50: 15.3, p85: 16.9, p97: 18.4 },
  { month: 54, p3: 12.9, p15: 13.9, p50: 15.3, p85: 16.9, p97: 18.4 },
  { month: 55, p3: 12.9, p15: 13.9, p50: 15.3, p85: 16.9, p97: 18.4 },
  { month: 56, p3: 12.8, p15: 13.8, p50: 15.3, p85: 16.9, p97: 18.5 },
  { month: 57, p3: 12.8, p15: 13.8, p50: 15.3, p85: 16.9, p97: 18.5 },
  { month: 58, p3: 12.8, p15: 13.8, p50: 15.3, p85: 16.9, p97: 18.5 },
  { month: 59, p3: 12.8, p15: 13.8, p50: 15.3, p85: 16.9, p97: 18.5 },
  { month: 60, p3: 12.8, p15: 13.8, p50: 15.3, p85: 17, p97: 18.6 }
]
